export const MinortStartRoutesSegments = {
  OutOfJurisdiction: 'out-of-jurisdiction',
  Account: 'account',
  ResidencyConfirmation: 'residency-confirmation',
  Invitation: 'invitation',
  Preview: 'preview',
} as const;
